import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY, map, Observable, switchMap } from 'rxjs';
import { AiChatApiService } from '@panaya/ai-chat/domain';
import { AiChatThreadService } from './ai-chat-thread.service';

/**
 * Service that fetches suggestions from the API when thread changes.
 *
 * This service:
 * - Observes thread ID changes
 * - Calls the suggestions API endpoint
 * - Lets the interceptor handle storing results in the provider
 *
 */
@Injectable({ providedIn: 'root' })
export class AiChatSuggestionsFetcherService {
    private readonly ai = inject(AiChatApiService);
    private readonly threadService = inject(AiChatThreadService);

    /**
     * Observable that triggers suggestions fetching when subscribed.
     * Subscribe to this in the template using ng-let to start fetching.
     * Returns void - the actual suggestions are handled by the interceptor.
     */
    public readonly trigger$: Observable<void> = this.threadService.id.pipe(
        switchMap(() =>
            this.ai.getSuggestions().pipe(
                catchError((error) => {
                    console.warn('Failed to fetch suggestions', error);
                    return EMPTY;
                })
            )
        ),
        map(() => void 0) // Don't emit the response, just void
    );
}
